import { Controller } from "@hotwired/stimulus"

// Opens the new timesheet form in a side drawer via turbo stream
// This controller bypasses turbo frame handling to properly trigger turbo stream responses
export default class extends Controller {
  static values = {
    url: String,
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    const csrfToken = document.head
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content")

    fetch(this.urlValue, {
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then(async (response) => {
        const contentType = response.headers.get("Content-Type") || ""
        const html = await response.text()

        if (contentType.includes("text/vnd.turbo-stream.html")) {
          Turbo.renderStreamMessage(html)
        }
      })
      .catch((error) => {
        console.error("Error opening new timesheet form:", error)
      })
  }
}
